import { ListingBuyerAlertModel } from '@steelbuy/ts-shared';

import { ListingBuyerAlertCollectionData } from './ListingBuyerAlertCollectionData';
import { useCollectionData } from '../../util/consumer/CollectionConsumerHook';

export const useListingBuyerAlertCollectionData = () =>
    useCollectionData<ListingBuyerAlertModel>(ListingBuyerAlertCollectionData);
